function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus?.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

document.querySelectorAll('details').forEach(button => {
  button.addEventListener('click', () => {
    if (button.closest('details').getAttribute('aria-expanded') == 'false') {
      button.closest('details').setAttribute('aria-expanded', 'true')
    }
    else {
      button.closest('details').setAttribute('aria-expanded', 'false')
    }
  })
})

document.querySelectorAll('.quantity__button').forEach(button => {
  button.addEventListener('click', () => {
    document.getElementById('quantity__input').focus();
  })
})
if (document.getElementById('cart-icon-bubble')){
  document.getElementById('cart-icon-bubble').addEventListener('click', () => {
    document.getElementById('title-wrapper-with-link').focus();
  })
  
}



function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}
function resumeAllPopupOpeners() {
  document.querySelectorAll('deferred-media > modal-opener  > button > video').forEach((video) => {
    video.play()
  });
}

function resumeAllPopupOpeners() {
  document.querySelectorAll('deferred-media > modal-opener  > button > video').forEach((video) => {
    video.play()
  });
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.focus();
}

function updateHistoryState(query) {
  if (!history.replaceState) return;

  query = query ? encodeURIComponent(query) : '';
  const newURL = updateQueryStringParameter("s", query);
  window.history.replaceState({ path: newURL }, "", newURL);
}

function getQueryParams (qs) {
  qs = qs || document.location.search;

  if (!qs) {
    return;
  }

  qs = qs.split('+').join(' ');

  var params = {},
    tokens,
    re = /[?&]?([^=]+)=([^&]*)/g;

  while (tokens = re.exec(qs)) {
    params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
  }

  return params;
}

function updateQueryStringParameter(key, value, url){
  if (!url) url = window.location.href;

  var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
    hash;

  if (re.test(url)) {
    if (typeof value !== 'undefined' && value !== null)
      return url.replace(re, '$1' + key + "=" + value + '$2$3');
    else {
      hash = url.split('#');
      url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
      if (typeof hash[1] !== 'undefined' && hash[1] !== null)
        url += '#' + hash[1];
      return url;
    }
  } else {
    if (typeof value !== 'undefined' && value !== null) {
      var separator = url.indexOf('?') !== -1 ? '&' : '?';
      hash = url.split('#');
      url = hash[0] + separator + key + '=' + value;
      if (typeof hash[1] !== 'undefined' && hash[1] !== null)
        url += '#' + hash[1];
      return url;
    }
    else
      return url;
  }
}



class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

Shopify.loadElements = function(data,selectors,parent = document){
  Object.keys(selectors).forEach(key => {
    if (key[0] === '#'){
      data[key] = parent.getElementById(selectors[key].substring(1));
    }
    else if (key.slice(-1) === 's'){
      data[key] = parent.querySelectorAll(selectors[key]);
    }
    else {
      data[key] = parent.querySelector(selectors[key]);
    }
  });
};

Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => {
      summary.addEventListener('click', this.onSummaryClick.bind(this));
      
      summary.addEventListener('touchstart', this.onTouchStart.bind(this), { passive: true });
      summary.addEventListener('touchend', this.onTouchEnd.bind(this));
    });

    // Add touch events for links within the menu drawer (non-summary elements)
    this.querySelectorAll('a').forEach(link => {
      if (!link.closest('summary')) { // Only target links that aren't inside summary elements
        link.addEventListener('touchstart', this.onLinkTouchStart.bind(this), { passive: true });
        link.addEventListener('touchend', this.onLinkTouchEnd.bind(this));
      }
    });

    this.querySelectorAll('button').forEach(button => {
      button.addEventListener('click', this.onCloseButtonClick.bind(this));
      
      button.addEventListener('touchstart', this.onButtonTouchStart.bind(this), { passive: true });
      button.addEventListener('touchend', this.onButtonTouchEnd.bind(this));
    });
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const currentId = detailsElement.dataset.toggleId;
  
    if (detailsElement === this.mainDetailsToggle) {
      console.log('mainDetailsToggle');
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    }
    else if (currentId) {
      console.log('currentId');
      if (detailsElement.open){
        event.preventDefault();
        summaryElement.open = true;
        detailsElement.ariaSelected = true;
      }
      else {
        console.log('else');
        let parent = summaryElement.closest('ul');
        let siblings = parent.querySelectorAll(`details:not([data-toggle-id="${currentId}"]`);
        siblings.forEach(details => {
          details.open = false;
          details.ariaSelected = false;
        });

        detailsElement.setAttribute('open', '');
        summaryElement.open = true;
        detailsElement.ariaSelected = true;
      }
      
    }  
    else {
      
      detailsElement.setAttribute('open', '');
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }
  
  openMenuDrawer(summaryElement) {
    
    this.mainDetailsToggle.setAttribute('open', '');
    
    this.mainDetailsToggle.classList.add('menu-opening');
    
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        if (details.dataset.toggleId){
          //don't close all tabs
        }
        else {
          details.removeAttribute('open');
          details.classList.remove('menu-opening');
        }
        
      });
      
      setTimeout(() => {
        this.mainDetailsToggle.removeAttribute('open');
      }, 100);
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    
    detailsElement.classList.remove('menu-opening');
    
    const summaryElement = detailsElement.querySelector('summary');
    if (summaryElement) {
      summaryElement.setAttribute('aria-expanded', false);
    }
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        
        this.isClosing = true;
        
        
        detailsElement.removeAttribute('open');
        
        
        setTimeout(() => {
          this.isClosing = false;
        }, 100);
        
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }

  
  onTouchStart(event) {
    this.touchStartX = event.changedTouches[0].screenX;
    this.touchStartY = event.changedTouches[0].screenY;
    this.touchStartTime = new Date().getTime();
    this.touchedElement = event.currentTarget;
    this.touchMoved = false;
  }

  onTouchEnd(event) {
    if (!this.touchedElement) return;
    
    const touchEndX = event.changedTouches[0].screenX;
    const touchEndY = event.changedTouches[0].screenY;
    const touchEndTime = new Date().getTime();
    
    
    const touchTime = touchEndTime - this.touchStartTime;
    const distX = Math.abs(touchEndX - this.touchStartX);
    const distY = Math.abs(touchEndY - this.touchStartY);
    
    
    if (touchTime < 500 && distX < 20 && distY < 20) {
      event.preventDefault();
      event.stopPropagation();
      
      
      const summaryElement = this.touchedElement;
      const detailsElement = summaryElement.parentNode;
      const isOpen = detailsElement.hasAttribute('open');
      const currentId = detailsElement.dataset.toggleId;
      
      if (detailsElement === this.mainDetailsToggle) {
        if (isOpen) {
          this.closeMenuDrawer(summaryElement);
        } else {
          
          detailsElement.setAttribute('open', '');
          this.openMenuDrawer(summaryElement);
        }
      }
      else if (currentId) {
        if (detailsElement.open) {
          event.preventDefault();
          summaryElement.open = true;
          detailsElement.ariaSelected = true;
        }
        else {
          let parent = summaryElement.closest('ul');
          let siblings = parent.querySelectorAll(`details:not([data-toggle-id="${currentId}"]`);
          siblings.forEach(details => {
            details.open = false;
            details.ariaSelected = false;
          });
          
          
          detailsElement.setAttribute('open', '');
          summaryElement.open = true;
          detailsElement.ariaSelected = true;
          
          
          detailsElement.classList.add('menu-opening');
        }
      }
      else {
        
        detailsElement.setAttribute('open', '');
        trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
        
        detailsElement.classList.add('menu-opening');
      }
    }
    
    
    this.touchedElement = null;
  }

  
  onButtonTouchStart(event) {
    this.buttonTouchStartX = event.changedTouches[0].screenX;
    this.buttonTouchStartY = event.changedTouches[0].screenY;
    this.buttonTouchStartTime = new Date().getTime();
    this.buttonTouchedElement = event.currentTarget;
  }

  onButtonTouchEnd(event) {
    if (!this.buttonTouchedElement) return;
    
    const touchEndX = event.changedTouches[0].screenX;
    const touchEndY = event.changedTouches[0].screenY;
    const touchEndTime = new Date().getTime();
    
    
    const touchTime = touchEndTime - this.buttonTouchStartTime;
    const distX = Math.abs(touchEndX - this.buttonTouchStartX);
    const distY = Math.abs(touchEndY - this.buttonTouchStartY);
    
    
    if (touchTime < 500 && distX < 20 && distY < 20) {
      event.preventDefault();
      event.stopPropagation();
      
      const detailsElement = this.buttonTouchedElement.closest('details');
      this.closeSubmenu(detailsElement);
    }
    
    
    this.buttonTouchedElement = null;
  }

  // Touch event handlers for regular links
  onLinkTouchStart(event) {
    this.linkTouchStartX = event.changedTouches[0].screenX;
    this.linkTouchStartY = event.changedTouches[0].screenY;
    this.linkTouchStartTime = new Date().getTime();
    this.linkTouchedElement = event.currentTarget;
  }

  onLinkTouchEnd(event) {
    if (!this.linkTouchedElement) return;
    
    const touchEndX = event.changedTouches[0].screenX;
    const touchEndY = event.changedTouches[0].screenY;
    const touchEndTime = new Date().getTime();
    
    const touchTime = touchEndTime - this.linkTouchStartTime;
    const distX = Math.abs(touchEndX - this.linkTouchStartX);
    const distY = Math.abs(touchEndY - this.linkTouchStartY);
    
    // If it's a tap (short touch, small movement)
    if (touchTime < 500 && distX < 20 && distY < 20) {
      // Prevent default behavior to avoid double-handling
      event.preventDefault();
      event.stopPropagation();
      
      // Get the link and navigate immediately
      const href = this.linkTouchedElement.getAttribute('href');
      if (href) {
        // Use immediate navigation
        window.location.href = href;
      } else {
        // If no href, try triggering a click event
        this.linkTouchedElement.click();
      }
    }
    
    this.linkTouchedElement = null;
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.theme-section-header') || document.querySelector('[id^="shopify-section-header"]');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    // Explicitly set the open attribute before adding menu-opening class
    this.mainDetailsToggle.setAttribute('open', '');
    // Apply menu-opening class immediately without delay for mobile
    this.mainDetailsToggle.classList.add('menu-opening');

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class AjaxCart extends HTMLElement {
  constructor() {
    super();
    this.cartDrawer = this.querySelector('cart-drawer');
    this.cartIcon = document.getElementById("cart-icon-bubble");
    this.cartIcon.addEventListener('click', this.toggle.bind(this));
    this.headerHamburger = document.querySelector(".header__icon--menu");
    this.headerHamburger.addEventListener('click', this.headerClose.bind(this));
    // this.swipeMove.bind(this);
    this.bindEvents();
    this.preventTabsOutsideModal()
  }

  preventTabsOutsideModal() {
    this.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab') return;
      const dialog = this.querySelector('cart-drawer');
      if (!dialog) return;
      const focusable = getFocusableElements(dialog).filter((el) => el.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey && e.target === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && e.target === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }
  
  bindEvents() {
    this.cartClose = this.querySelector('.cart__close');
    this.cartClose.addEventListener('click', this.close.bind(this));
    this.backdrop = this.querySelector('backdrop');
    this.backdrop.addEventListener('click', this.close.bind(this));
    this.swipeMove();
  }

  swipeMove() {
    let startX, startY, distX, distY
    this.querySelector('cart-drawer').addEventListener('touchstart', (e) => {
      var touchobj = e.changedTouches[0];
      startX = touchobj.pageX
      startY = touchobj.pageY
    });
    this.querySelector('cart-drawer').addEventListener('touchend', (e) => {
      var touchobj = e.changedTouches[0];
      distX = touchobj.pageX - startX 
      distY = touchobj.pageY - startY;
      if(distX > 80) {
        e.preventDefault();
        this.close(e);
      }
    });
  }

  toggle(event) {
    event.preventDefault();
    event.stopPropagation();
    return this.hasAttribute("open") ? this.close() : this.open();
  }
  
  open(event) {
    this.cartDrawer.classList.add('animate', 'active');
    this.setAttribute("open", "");
    if (!document.body.classList.contains('ajax-cart-open') && !this.contains(document.activeElement)) {
      this.triggerElement = document.activeElement;
    }
    document.body.classList.add(`ajax-cart-open`);
    this.focusDrawer();
  }

  focusDrawer() {
    const focusTarget = () => {
      const closeButton = this.querySelector('.cart__close');
      if (!closeButton || this.contains(document.activeElement)) return;
      closeButton.focus({ preventScroll: true });
    };
    focusTarget();
    [50, 350].forEach((delay) => setTimeout(focusTarget, delay));
  }

  headerClose(event) {
    if(document.body.classList.contains(`ajax-cart-open`)) {
      event.stopPropagation();
      event.preventDefault();
      this.close(event);
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  close(event) {
   if (!event || event.type == "click") {
      this.removeAttribute("open", "");
      document.body.classList.remove(`ajax-cart-open`);
      document.body.classList.remove('overflow-hidden');
      document.body.classList.remove('overflow-hidden-tablet');
      if (this.triggerElement && document.contains(this.triggerElement)) this.triggerElement.focus();
      this.triggerElement = null;
    }

  }

  initializeWishlistButtons() {
    try {
      if("_swat" in window)   _swat.initializeActionButtons("#shopify-section-ajax-cart");
    } catch (error) {
    console.warn (error)
    }
  
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section => {
      var sectionToUpdate = document.getElementById(section.id);
      if(sectionToUpdate) sectionToUpdate.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));
    setTimeout(() => {
      this.initializeWishlistButtons();
      this.open();
    
      new CartTermsAnsConditions();
      window.checkFreeShippings();

    }, 100);
    this.bindEvents();
  }
  getSectionsToRender() {
    return [
      {
        id: 'ajax-cart',
        selector: `#ajax-cart`,
      },
      {
        id: 'cart-promos',
        selector: '#gift-with-purchase'
      },
      {
        id: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('ajax-cart', AjaxCart);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    if (!this.querySelector('[id^="ModalClose-"]')) return;
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    this.classList.remove("hidden");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
    if (this.classList.contains("video-popup-modal")) {
      this.querySelector('iframe').src += "&autoplay=1";
    }
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    this.classList.add("hidden");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
    if (this.classList.contains("video-popup-modal")) {
      var iframe = this.querySelector('iframe');
      iframe.src = iframe.src.replace("&autoplay=1", "");
      window.resumeAllPopupOpeners();
    }
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class ColourSwatches extends HTMLElement {
  constructor() {
    super();

    this.container = this.querySelector('.colour-swatches__container');
    this.settings = this.setSettings();
    var hideIfEmpty = this.settings.hideIfEmpty;
    if (this.settings.groupTag) {
      fetch(`/collections/all/${encodeURIComponent(this.settings.groupTag)}?view=data`)
        .then((response) => response.json())
        .then((responseJson) => {
          this.initSwatches(responseJson);
          this.setCurrent();
          this.hideIfEmpty(hideIfEmpty)
      });
    } else {
      this.hideIfEmpty(hideIfEmpty);
    }
  }

  hideIfEmpty(hideIfEmpty) {
    if (!hideIfEmpty) return;

    const swatches = this.querySelectorAll('.colour-swatches__container input');
    if (swatches.length > 0) return;

    this.classList.add("swatch-empty--hide");
  }

  setSettings() {
    const settingsRawJson = this.querySelector("#swatches-settings");
    if(!settingsRawJson) return {}
    return JSON.parse(settingsRawJson.innerHTML);
  }

  initSwatches(products) {
    var html = "";
    const swatchType = this.settings.swatch_type || 'square';
    products.forEach(product => {
      if (this.settings.hiddeOptionsOutOfStock) {
        if (product.available) {
          const imgSrc = this.getProductImageSrc(product)
          const el = `<input ${this.settings.location=='product'&&this.settings.product_handle==product.handle ? 'class="current"' : ''} swatch-input type="image" aria-label="${product.handle}" data-handle="${product.handle}" data-available="${product.available}" data-swatch-type="${swatchType}" src="${imgSrc}" data-href="/products/${product.handle}">`;
          html += el
        }
      } else {
        const imgSrc = this.getProductImageSrc(product)
        const el = `<input ${this.settings.location=='product'&&this.settings.product_handle==product.handle ? 'class="current"' : ''} swatch-input type="image" aria-label="${product.handle}" data-handle="${product.handle}" data-available="${product.available}" data-swatch-type="${swatchType}" src="${imgSrc}" data-href="/products/${product.handle}">`;
        html += el
      }
    })
    if(html) {
      this.container.innerHTML = html

      const swatchInputs = this.container.querySelectorAll("[swatch-input]");
      const swatchInputsLength = swatchInputs.length;
      for (let i = 0; i < swatchInputsLength; i++) {
        swatchInputs[i].addEventListener("click", function(e) {
          //console.log(e);
          const element = e.currentTarget;
          const redirectUrl = element.dataset.href;
          
          window.location.href = redirectUrl;
        });
      }
    }


  }

  getProductImageSrc(product) {
    var imageSrc = product.featured_image;
    switch (this.settings.image_type) {
      case "image_swatch":
        const colourTag = product.tags.find(tag => tag.indexOf(this.settings.colourTagPrefix) > -1);
        if(colourTag) {
          const colour = colourTag.replace(this.settings.colourTagPrefix, "").toLowerCase();
          imageSrc = "https:" + this.settings.swatchUrl.replace("swatch", `colour-${colour}`);
        }
        break;
      case "first_variant_image":
      const firstVariantImage = product.variants[0].image;
        if(firstVariantImage) imageSrc = firstVariantImage;
        break;
      case "last_variant_image":
        const lastVariantImg = product.variants[product.variants.length - 1].image;
        if(lastVariantImg) imageSrc = lastVariantImg;
        break;
      case "featured_image":
        // product.featured_image is already the default, nothing to do
        break;
      case "swatch_image":
        if (product.swatch_image) imageSrc = product.swatch_image;
        break;
      case "swatch_hex": {
        const rawHex = product.swatch_hex;
        const hexColor = rawHex ? (String(rawHex).startsWith('#') ? rawHex : '#' + rawHex) : 'transparent';
        imageSrc = 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(
          `<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35"><rect width="35" height="35" fill="${hexColor}"/></svg>`
        );
        break;
      }
      default:
        break;
    }
    return imageSrc;
  }

  getProductImage(product) {
    const imageSrc = this.getProductImageSrc(product);
    const image = `<img src="${imageSrc}">`;
    return image;
  }

  setCurrent() {
    this.container.querySelector(`[data-handle="${window.current.product.handle}"]`).classList.add("selected");
  }
}
customElements.define('colour-swatches', ColourSwatches);
class ProductGridColourSwatches extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('li').forEach(li => {
      li.addEventListener('click', this.switchImageTitleAndLink.bind(this));
    });
  }

  switchImageTitleAndLink(evt) {
    if(evt.currentTarget.classList.contains('active')) return;

    this.querySelectorAll('li').forEach(li => li.classList.remove('active'));

    // Update Image
    const imageElement = this.closest('.card-wrapper').querySelector('.media > img');
    const newImageUrl = evt.currentTarget.getAttribute('data-image');
    imageElement.removeAttribute('srcset');
    imageElement.src = newImageUrl;

    // Update link url
    const linkElement = this.closest('.card-wrapper').querySelector('a.media');
    const newLinkUrl = evt.currentTarget.getAttribute('data-product-url');
    linkElement.href = newLinkUrl;

    // Update product title
    const titleElement = this.closest('.card-wrapper').querySelector('.card-information__text a');
    const newTitle = evt.currentTarget.getAttribute('data-product-title');
    titleElement.href = newLinkUrl;
    titleElement.innerText = newTitle;

    // Update product price
    const priceElement = this.closest('.card-wrapper').querySelector('.card-information .price');
    const newPrice = evt.currentTarget.getAttribute('data-product-price');
    priceElement.innerText = newPrice;

    evt.currentTarget.classList.add('active');
  }
}
customElements.define('product-grid-colour-swatches', ProductGridColourSwatches);
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
    if(this.dataset.autoplay) poster.click()
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe'));
      const self = this
      if(this.querySelector("video")) this.querySelector("video").play()
      if(document.querySelector("#video-video")) document.querySelector("#video-video").contentWindow.postMessage('{"method":"play"}', '*');
      setTimeout(function() {
        const vimeoVideo = self.querySelector("iframe.js-vimeo");
        if(vimeoVideo) vimeoVideo.contentWindow.postMessage('{"method":"play"}', '*');
      }, 2000)
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.progressBar = this.querySelector('.slider-progress-bar');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => {
      this.initPages();
      this.syncSlideAccessibility();
    });
    resizeObserver.observe(this.slider);
    this.observeSlideVisibility();

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

    /** Desktop drag to scroll */
    let isDown = false;
    let startX;
    let scrollLeft;
    this.slider.addEventListener('mousedown', (e) => {
      isDown = true;
      startX = e.pageX - this.slider.offsetLeft;
      scrollLeft = this.slider.scrollLeft;
    });
    this.slider.addEventListener('mouseleave', () => {
      isDown = false;
    });
    this.slider.addEventListener('mouseup', () => {
      isDown = false;
    });
    this.slider.addEventListener('mousemove', (e) => {
      if(!isDown) return;
      e.preventDefault();
      const x = e.pageX - this.slider.offsetLeft;
      const walk = (x - startX) * 3;
      this.slider.scrollLeft = scrollLeft - walk;
    });
  }

  

  observeSlideVisibility() {
    if (!('IntersectionObserver' in window)) return;
    this.visibleSlides = new Set();
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) this.visibleSlides.add(entry.target);
        else this.visibleSlides.delete(entry.target);
      });
      this.syncSlideAccessibility();
    }, { root: this.slider, threshold: 0.6 });
    this.sliderItems.forEach((item) => observer.observe(item));
  }

  syncSlideAccessibility() {
    if (!this.visibleSlides) return;
    const isScrollable = this.slider.scrollWidth > this.slider.clientWidth + 1;
    this.sliderItems.forEach((item) => {
      const hide = isScrollable && item.clientWidth > 0 && !this.visibleSlides.has(item);
      if (hide) item.setAttribute('aria-hidden', 'true');
      else item.removeAttribute('aria-hidden');
      item.querySelectorAll('a[href], button, input, select, textarea, [tabindex]').forEach((el) => {
        if (hide) {
          if (el.dataset.a11yTabindex === undefined) el.dataset.a11yTabindex = el.getAttribute('tabindex') || '';
          el.setAttribute('tabindex', '-1');
        } else if (el.dataset.a11yTabindex !== undefined) {
          if (el.dataset.a11yTabindex === '') el.removeAttribute('tabindex');
          else el.setAttribute('tabindex', el.dataset.a11yTabindex);
          delete el.dataset.a11yTabindex;
        }
      });
    });
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);

    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }



  update() {
    if (!this.pageCount || !this.pageTotal) {
      return;
    }
    let count = parseInt(this.pageCount.innerText)
    let total = parseInt(this.pageTotal.innerText)

    if(this.progressBar){
      let percentage = (count / total) * 100
      percentage = (percentage + '%')
      this.progressBar.style.width = percentage
    }

    if (!this.pageCount || !this.pageTotal || !this.sliderLastItem) return;
    let sliderLastItemClientWidth = this.sliderLastItem.clientWidth;
    if (this.classList.contains("special--slider")) {
      var computedStyle = getComputedStyle(this.sliderLastItem);
      sliderLastItemClientWidth -= parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight)
    }

    const lastPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / sliderLastItemClientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', true);
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', true);
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    // if(this.currentPage !== 1 && this.currentPage === lastPage) this.nextButton.setAttribute('disabled', true);

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    this.classList.remove('slider-component__slider--hover');
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
    //this.update();
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.updateOptions();
    this.updateMasterId();
    this.updateAvailability();
    this.updateSelectedOption();
    this.toggleOutOfStockLabel();
    this.updateCurrentSku();
    this.updateBNPLPrices();
    this.updateAfterPayPrice();
    this.updateChangedOption();
    this.updatePriceDiffrences(true);
  }

  onVariantChange(event) {
    try {
      this.updateChangedOption(event);
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(false, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateSelectedOption();
      this.toggleOutOfStockLabel();
      this.updateCurrentSku();
      this.updateBNPLPrices();
      this.updateAfterPayPrice();
      this.updateOptionTextEvent(event);
      this.updatePriceDiffrences();

    } catch (error) {
      console.log(error);
      this.updateOptionTextEvent(event)
      this.updatePriceDiffrences();
    }

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
      this.resetPriceDifferences();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateSwymBtn();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  
  
  
    setTimeout(() => {
      let buttonProduct = document.querySelector('button.product-form__submit.button.button--full-width.button--secondary');
      let headerProduct = document.querySelector('.js-sticky-product-add');

      if (buttonProduct && headerProduct) {
        if (buttonProduct.disabled == true) {
          headerProduct.classList.add('sticky-product-add--remove');
        }
        else {
          headerProduct.classList.remove('sticky-product-add--remove');
        }
      }
    }, "1000")
  }

  updateOptionTextEvent(event) {
    const hasOptionText = document.querySelectorAll('.information_message');
    if (!hasOptionText) return
    
    const optionIndex = event.target.dataset.optionIndex;
    let optionValue = event.target.value;
    if (optionIndex == "option2" || optionIndex == "option3") {
      return
    }
    // if (!this.currentVariant) {
    //   optionValue = "";
    // }
    const formId = event.currentTarget.dataset.section; 
    //console.log({formId})
    this.updateOptionText(optionIndex, optionValue, formId);
  }

  updateOptionText(optionIndex, optionValue, formId) {
    if (optionIndex == "option1" && optionValue.toLowerCase().includes("two motors")) {
      let elements = document.querySelectorAll(`form#product-form-${formId} fieldset .information_message`);
      for (let i=0; i < elements.length; i++) {
        elements[i].classList.remove("hide");
        const selectedSecondOption = document.querySelector(`form#product-form-${formId} input[data-option-index="option2"]:checked`);
        const nextOption = document.querySelector(`form#product-form-${formId} input[data-option-index="option2"]:checked ~ input`);
        //console.log(selectedSecondOption, nextOption);
        if (selectedSecondOption && selectedSecondOption.value.toLowerCase().indexOf('one') > -1) {
          selectedSecondOption.checked = false
          nextOption.checked = true
          this.updateOptions();
          this.updateMasterId();
          this.updateAvailability();
          this.updateSelectedOption();
          this.toggleOutOfStockLabel();
          this.updateCurrentSku();
          this.updateBNPLPrices();
          this.updateAfterPayPrice();
          this.updateChangedOption();
          this.updatePriceDiffrences(true);
        }
      }
    } else {
      let elements = document.querySelectorAll(`form#product-form-${formId} fieldset .information_message`);
      for (let i=0; i < elements.length; i++) {
        elements[i].classList.add("hide");
      }
    }
  }

  updateChangedOption(event) {
    console.log('updateChangedOption')
    try {
      if(event) {
        this.optionIndex = event.target.dataset.optionIndex;
        this.optionValue = event.target.value;
      } else {
        let selector = document.querySelector(`#product-form-${this.dataset.section} [data-option-index="option1"]:checked`);
        if (selector) {
          this.optionIndex = "option1";
          this.optionValue = selector.value;
        }
      }
    } catch (error) {
      console.log(error);
    }
   
    
    if(this.optionIndex) {
      const self = this
      const variants = this.getVariantData();
      const availableVariants = variants.filter(v => v[this.optionIndex] === this.optionValue)
      for (let i = 1; i < 4; i++) {
        const optionSelector = "option" + i;
        if(optionSelector === this.optionIndex) continue;
        if(optionSelector === "option1") continue;
        self.querySelectorAll(`input[data-option-index="${optionSelector}"]`).forEach(el => {
          el.disabled = true;
          availableVariants.map(av => {
            if(av[optionSelector] === el.value) {
              el.disabled = false;
            }
          })
        });
      }
    }
  }

  resetPriceDifferences() {
    this.querySelectorAll(".price-increase").forEach(el => {
      el.innerHTML = ""
    })
  }

  updatePriceDiffrences(isPageLoad) {
    var self = this;
    const allVariants = this.getVariantData();

    this.querySelectorAll(".price-increase").forEach(el => {
      const currentIndex = el.dataset.optionIndex;
      const currValue = el.dataset.optionValue;

      const otherOptions = [
        self.currentVariant.option1 && currentIndex != "option1" ? "option1" : null,
        self.currentVariant.option2 && currentIndex != "option2" ? "option2" : null,
        self.currentVariant.option3 && currentIndex != "option3" ? "option3" : null 
      ].filter(option => option);

      const targetVariant = allVariants.find(v => {
        var pass = true;
        otherOptions.forEach(other => {
          if(v[other] != self.currentVariant[other]) pass = false
        })
        return v[currentIndex] == currValue && pass
      })
      if(targetVariant) {
        const difference = (targetVariant.price - self.currentVariant.price) / 100;
        el.innerHTML = `${difference > 0 ? "+" : difference <0 ? "-": "+" }$${Math.abs(difference)}`
      } else {
        const inputEl = self.querySelector(`input[data-option-index="${currentIndex}"][value="${currValue}"]`)
        
        if(inputEl) {
          //console.log(currentIndex)
          if(currentIndex == 'option1') {
            console.log('skipping two motors at page load')
          } else {
            inputEl.disabled = true
          }
        }
        el.innerHTML = ""
      }
    });
  }

  updateSelectedOption() {
    if (this.currentVariant) {
      document.querySelectorAll("[data-selected-option]").forEach(el => {
        el.textContent = this.currentVariant[el.dataset.selectedOption];
      });
    }
  }

  updateAvailability() {
    const variants = this.getVariantData();
    variants.map(variant => {
      if(variant.option2 && !variant.available) {
        document.querySelector(`.product-form__input input[value="${variant.option2}"]`).classList.add("disabled");
        document.querySelector(`.product-form__input label[value="${variant.option2}"]`).setAttribute("disabled","");

      }
    })
  }

  updateUnavailableVariants() {
    //console.log(this.getVariantData());
  }

  toggleOutOfStockLabel() {
    if (!this.currentVariant) return;
    const outOfStockLabel = document.querySelector('[data-out-of-stock]');
    if(!outOfStockLabel) return;
    if(!this.currentVariant.available) outOfStockLabel.classList.remove("visibility-hidden")
    else outOfStockLabel.classList.add("visibility-hidden")

    let ossSelector = document.querySelector('.oos_link')
    if(!ossSelector) return;
    let ossLink = ossSelector.href
    let currentSize = ''
    currentSize = this.currentVariant.option2
    currentSize = encodeURIComponent(currentSize)
    ossLink = ossLink.split('&')
    ossSelector.href = ossLink[0] + '&' + 'pf_opt_size=' + currentSize
    
  }

  updateCurrentSku() {
    const currentSku = document.querySelector('[data-current-sku]');
    if(!currentSku) return;
    currentSku.textContent = this.currentVariant.sku;
  }
  
  updateBNPLPrices() {
    const paymentBlocksContainer = document.getElementsByClassName('payment-blocks-container');
    if (!paymentBlocksContainer) return;

    const blockSelector = document.querySelectorAll('.payment-block-element');

    blockSelector.forEach(e => {
      const instalments = e.querySelector('.instalments');
      const instalmentPrice = e.querySelector('.price-instalments');

      const priceAfterInstalments = this.currentVariant.price/100/parseInt(instalments.textContent);

      const priceAfterInstalmentsRounded = Math.round((priceAfterInstalments + Number.EPSILON) * 100) / 100
      instalmentPrice.textContent = ('$' + priceAfterInstalmentsRounded);
    });
  }

  updateAfterPayPrice() {
    const afterPayPrice = document.getElementById("price-instalments-afterpay");
    if (!afterPayPrice) return;

    const priceAfterInstalments = this.currentVariant.price / 100 / 4;
    const priceAfterInstalmentsRounded = Math.round((priceAfterInstalments + Number.EPSILON) * 100) / 100;

    if (Shopify.currency.active == "AUD" || Shopify.currency.active == "NZD" || Shopify.currency.active == "SGD"){
      afterPayPrice.textContent = ("$" + priceAfterInstalmentsRounded.toFixed(2) + " " + Shopify.currency.active + " fortnightly with ");
    }
    else if (Shopify.currency.active == "USD"){
      afterPayPrice.textContent = ("$" + priceAfterInstalmentsRounded.toFixed(2) + " " + Shopify.currency.active + " with ");
    }
    else if (Shopify.currency.active == "EUR"){
      afterPayPrice.textContent = ("€" + priceAfterInstalmentsRounded.toFixed(2) + " " + Shopify.currency.active);
    }
    else {
      afterPayPrice.textContent = (priceAfterInstalmentsRounded.toFixed(2) + " " + Shopify.currency.active);
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
    // update sticky bar
    var sticky_select = document.querySelector('.js-sticky-product-add #size-selector')
    if (sticky_select){
      var options = sticky_select.options; // Get all the options in the select
      var currentVariantId = this.currentVariant.id; // Assuming this is available
  
      // Loop through the options
      for (var i = 0; i < options.length; i++) {
          if (options[i].value == currentVariantId) {
              options[i].selected = true; // Set the selected attribute
              break; // Exit the loop once found
          }
      }

    }
     //console.log("here current variant" , this.currentVariant.id);
  }

  updateMedia() {
    if (!this.currentVariant) return;
    // if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media?.id}"]`
    );

    if(newMedia) {
      const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
      const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
      const parent = newMedia.parentElement;
      if (parent.firstChild == newMedia) return;
      modalContent.prepend(newMediaModal);
      parent.prepend(newMedia);
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if(this.stickyHeader) {
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }
      window.setTimeout(() => { parent.querySelector('li.product__media-item').scrollIntoView({behavior: "smooth"}); });
    } 

    const variantImage = document.querySelector(`[data-variant-id="${this.dataset.section}-${this.currentVariant.sku}"]`);
    if(variantImage) {
      document.querySelectorAll(`[data-variant-id*="${this.dataset.section}"]`).forEach(el => el.classList.add("hidden"));
      variantImage.classList.remove("hidden");
    }

  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateSwymBtn() {
    if (!this.currentVariant) return;


    const swymBtn = document.querySelector(".swym-wishlist-button .swym-button");
    if (!swymBtn) return;

    swymBtn.dataset.variantId = this.currentVariant.id;
    try {
      if("_swat" in window)   _swat.initializeActionButtons("body");
    } catch (error) {
    console.warn (error)
    }
   
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment, #sticky-add-to-cart`);

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      const select = productForm.querySelector('select[name="id"]');
      input.value = this.currentVariant.id;
      if(select) {
        select.value = this.currentVariant.id;
      }
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const parts = this.dataset.section.split("---");
    const sectionId = parts[0];
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${sectionId}`)
      .then((response) => response.text())
      .then((responseText) => {
        var id = `price-${sectionId}`;
        if(parts[1]) id = id + "---" + parts[1]
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        
        const sticky_destination = document.querySelector(`sticky-product-add .sticky-product-info--price`);
        if (source && sticky_destination) sticky_destination.innerHTML = source.innerHTML;
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(id);
        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable , text, modifyClass) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;
    if (!disable) {
      // addButton.removeAttribute('disabled');
      addButton.classList.remove("unavailable");
      addButton.classList.remove("klaviyo-bis-trigger");
      addButton.style.display = "block"; //Need to override klaviyo default mechanism to hide notify me button if item is available
      console.log("here NOT  disable", disable)
      const decodeHtmlCharCodes = str => str.replace(/(&gt;)/g, ">");
      addButtonText.textContent = decodeHtmlCharCodes(window.variantStrings.addToCart);
      if(addButton.hasAttribute("data-button-pre-order")) {
        addButtonText.textContent = window.variantStrings.addToCartPreorder;
      }
    } else {
      if(addButton.hasAttribute("data-button-notify") && text == window.variantStrings.soldOut) text = window.variantStrings.notifyMe;
      // addButton.setAttribute('disabled', true);
      addButton.classList.add("unavailable");
      addButton.classList.add("klaviyo-bis-trigger");
      if (text) addButtonText.textContent = text;
      console.log("here disable", disable)

    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

Shopify.CountrySwitcher = function(){
  this.selectors = {
    countrySelectors: '[data-country-selector]',
    countrySwitcher: '.country-selector'
  };

  Shopify.loadElements(this,this.selectors);

  this.buildCountrySelectors();

  defer(this.buildBtnListener);

  function defer(method) {
    if (window.$) {
        method();
    } else {
        setTimeout(function() { defer(method) }, 50);
    }
  }
  
};

Shopify.CountrySwitcher.prototype = {
  
  buildCountrySelectors: function(){
    const self = this;
    
    for (let i = 0; i < self.countrySelectors.length; i++) {
      let placeholder = self.countrySelectors[i];
      let selector = self.countrySwitcher.cloneNode(true);

      placeholder.appendChild(selector);
    }

  },

  buildBtnListener: function() {
    const self = this;

    $('.country-selector--dropdown').on('click', function() {
      if ($(this).closest('.country-selector').attr('open')){
        $(this).closest('.country-selector').removeAttr('open');
        $(this).attr('aria-expanded',false);
      } else {
        $(this).closest('.country-selector').attr('open',true);
        $(this).attr('aria-expanded',true);
      }
    });
    $('.country-selector').on('click', function() {
      if ($(this).attr('open')){
        $(this).find('.country-selector--dropdown').attr('aria-expanded',false);
      } else {
        $(this).find('.country-selector--dropdown').attr('aria-expanded',true);
      }
    });

    $('.country-selector--dropdown').on('keydown', function(e) {
      if(e.key === 'Tab'|| e.key == 'Enter') {
        $(this).closest('.country-selector').attr('open','');
        $(this).attr('aria-expanded',true);
      }
    });

    $('.country-selector__link').on('keydown', function(e) {
      lastMenuItemIndex = $('.country-selector__options').attr('data-items-size');
      if((e.key === 'Tab' && !e.shiftKey && $(this).attr('data-index') == lastMenuItemIndex ) || e.key == 'Escape') {
        $(this).closest('details').removeAttr('open');
        $(this).closest('details').find('.country-selector--dropdown').attr('aria-expanded',false);
        
        // Move focus back to the menu toggle button if Escape was pressed
        if(e.key == 'Escape') {
          $(this).closest('details').find('.country-selector--dropdown').attr('aria-expanded',false);
          $(this).focus();
        }
      }
    });

    $('.country-selector--dropdown').on('keydown', function(e) {
      if(e.key == 'Enter') {
        //console.log('enter');
        $(this).closest('.country-selector').attr('open','');
        $(this).attr('aria-expanded',true);
      }
    });
  }

};

new Shopify.CountrySwitcher();

class BoostSearch {
  selectors = {
    searchInput: "search__input"
  };

  constructor() {
    this.initSearchInput();
  }

  initSearchInput() {
    let element = document.getElementsByClassName(this.selectors.searchInput);
    if (element.length < 0) return;
    for(let i = 0; i < element.length; i++) {
      let inputEl = element[i];
      inputEl.addEventListener('keyup', function(e){
        if (e.code == "Enter") {
          window.location.href = "/search?q=" + e.target.value;
        }
      })
    }
  }
};
new BoostSearch();

class CartTermsAnsConditions {

  selectors = {
    termsAndConditionsInput: "[data-terms-and-conditions-js]",
    checkoutButton: "[data-checkout-button]"
  }
  constructor(){
    //console.log('init terms and conditions');
    let termsAndConditionsInputs = document.querySelectorAll(this.selectors.termsAndConditionsInput);
    if (termsAndConditionsInputs.length < 1) return;

    this.initCheckoutButtonListener();
  }

  initCheckoutButtonListener() {
    let checkoutButtons = document.querySelectorAll(this.selectors.checkoutButton);
    checkoutButtons.forEach(function(button) {
      button.addEventListener("click", function(e) {
        let isAjax = e.currentTarget.dataset.isAjax;
        let checkbox;
        if (isAjax == "true") {
          checkbox = document.getElementById("termsAndConditions");
        } else {
          checkbox = document.getElementById("termsAndConditionsCart");
        }

        if (!checkbox.checked) {
          e.preventDefault();
          let text = checkbox.dataset.textPopup;
          alert(text);
        }
      })
    });
  }
}
new CartTermsAnsConditions();

class SizeChartSwitcher {

  constructor() {
    if (!document.querySelector('.product-form__size-switcher')) {
      return;
    }
    this.initSwitchListeners();
  }

  initSwitchListeners() {
    let switchButtons = document.querySelectorAll('[data-switch-button]');
    //console.log('a', switchButtons);
    for (let i = 0; i < switchButtons.length; i ++) {
      let switchButton = switchButtons[i];
      switchButton.addEventListener('click', function(e) {
        let buttons = document.querySelectorAll('[data-switch-button]');
        for (let i = 0; i < buttons.length; i ++) {
          buttons[i].classList.remove('active');
        }
        e.target.classList.add('active');

        let selectedChart = e.target.dataset.chartHandle;
        //console.log(selectedChart);

        let sizeValues = document.querySelectorAll('.size-value');
        for (let i = 0; i < sizeValues.length; i ++) {
          sizeValues[i].classList.remove('visible');
        }
        let sizeValuesToShow = document.querySelectorAll(`[data-${selectedChart}].size-value`);
        for (let i = 0; i < sizeValuesToShow.length; i ++) {
          sizeValuesToShow[i].classList.add('visible');
        }
      });
    }
  }
};
new SizeChartSwitcher();

/*============================================================================
  Scroll to utility
==============================================================================*/
window.theme = window.theme || {};

theme.scrollTo = (function () {
    // All list items
    function scrollTo(element) {
      window.scroll({
        behavior: 'smooth',
        left: 0,
        top: element.offsetTop
      });
    }
    
    document.addEventListener("DOMContentLoaded", function() {
      const menuItems = document.querySelectorAll('.js-unique-anchors__item');
      for (let i = 0; i < menuItems.length; i++) {
        let item = menuItems[i];
        item.addEventListener('click', (e) => {
          //console.log('click');
          e.preventDefault();
          let id = e.target.dataset.menu;
          let elem = document.getElementById(id);
          if (elem) {
            scrollTo(elem);
            this.drawer = document.querySelector('header-drawer');
            this.drawer.closeMenuDrawer(1);
          } else {
            const skateboardingHeader = document.querySelector('header.skateboarding--header');    
            if (skateboardingHeader.dataset.fallback && skateboardingHeader.dataset.fallback != "")
            document.location.href = `${skateboardingHeader.dataset.fallback}#${id}`;
          }
        });
      };
    });

    return;
})();

class ResponsiveNavList{
  menuItemsCount = 0;

  constructor() {
    let elements = document.querySelectorAll(".mega-menu-item:not(.in-dropdown)");
    this.menuItemsCount = elements.length;

    this.init();

    window.addEventListener('resize', this.refresh.bind(this));
  }

  init() {
    this.refresh();
  }

  calculateElementLength(element) {
    var menuItemWidthStyle =  element.currentStyle || window.getComputedStyle(element),
    width = element.offsetWidth,
    margin = parseFloat(menuItemWidthStyle.marginLeft) + parseFloat(menuItemWidthStyle.marginRight),
    padding = parseFloat(menuItemWidthStyle.paddingLeft) + parseFloat(menuItemWidthStyle.paddingRight),
    border = parseFloat(menuItemWidthStyle.borderLeftWidth) + parseFloat(menuItemWidthStyle.borderRightWidth);
    
    return width + margin - padding + border;  
  }

  calculateNumberOfElementVisible(elements, maxWidth) {
    let totalElementsWidth = 0;
    let elementsVisibles = 0;
    for (let element of elements) {
      totalElementsWidth += this.calculateElementLength(element);
      if (totalElementsWidth > maxWidth) {
        break;
      }
      elementsVisibles++;
    }

    return elementsVisibles;
  }

  refresh() {
    let elements = document.querySelectorAll(".mega-menu-item:not(.in-dropdown)");
    let navInlineWidth = document.querySelector(".header__inline-menu");
    let navInlineWidthMaxWidth = navInlineWidth.offsetWidth;

    let totalNumberOfElems = elements.length;
    let numberOfVisibleElems = this.calculateNumberOfElementVisible(elements, navInlineWidthMaxWidth);

    if (numberOfVisibleElems == 0) return;

    /** When total number of elements in menu are superior of possible element visible */
    if (totalNumberOfElems > numberOfVisibleElems) {
      this.dropInToMoreMenu(numberOfVisibleElems);
      this.toggleMoreMenu();
      return; // if we add item to menu we can be sure we do not have to remove items from menu
    }

    let inlineMenu = document.querySelector(".list-menu.list-menu--inline");
    let navInlineWidthNew = document.querySelector(".header__inline-menu");
    let remainingSpaceWidth = navInlineWidthNew.clientWidth - inlineMenu.clientWidth;

    let numberOfElemtToFit = Math.floor(remainingSpaceWidth / 145); //145 average menu item width
    if (numberOfElemtToFit > 0) {
      this.dropOffMoreMenu(numberOfElemtToFit);
      this.toggleMoreMenu();
    }
  }

  toggleMoreMenu() {
    let moreMenu = document.getElementById("menu-dropdown");
    let moreMenuItems = document.querySelectorAll("#menu-dropdown .mega-menu-item");
    if (moreMenuItems.length > 0) {
      moreMenu.classList.add('active');
    } else {
      moreMenu.classList.remove('active');
    }
  }

  dropOffMoreMenu(to) {
    let elements = document.querySelectorAll(".mega-menu-item.in-dropdown");
    let inlineMenu = document.querySelector(".list-menu.list-menu--inline");
    let moreMenu = document.getElementById("menu-dropdown");
    for (let i = 0; i < to; i++) {
      if (typeof(elements[i]) == 'undefined') break;

      let menuItemCloned = elements[i].cloneNode(true);
      menuItemCloned.classList.remove('in-dropdown');
      inlineMenu.insertBefore(menuItemCloned, moreMenu);
      elements[i].remove();
    }
  }

  dropInToMoreMenu(from) {
    let elements = document.querySelectorAll(".mega-menu-item");
    let moreMenu = document.getElementById("menu-dropdown");
    let moreMenuElements = moreMenu.querySelector(".mega-menu-dropdown");
    for (let i = from-1; i < elements.length; i++) {
      if (elements[i].getAttribute('id') == 'menu-dropdown') {
        continue;
      }
      let menuItemCloned = elements[i].cloneNode(true);
      menuItemCloned.classList.add('in-dropdown');
      moreMenuElements.appendChild(menuItemCloned);
      elements[i].remove();
    }
  }
}

new ResponsiveNavList();

class ArticleWrapper {
  constructor() {
    this.articleWrappers = document.querySelectorAll('[data-article-card]');
    this.articleWrappers.forEach(function(elem) {
      elem.addEventListener('click', function(event) {
        window.location.href = event.target.closest("article").dataset.href;
      });
    })
  }
}
new ArticleWrapper();

window.CANDYRACK_CAN_ATC = (_button) => {
  const label = document.getElementById('out-of-stock-label');
  if(!label.classList.contains('visibility-hidden')) {
    return false
  }
  return true
}

window.addEventListener('DOMContentLoaded', (event) => {
  const queryString = window.location.search;
  let urlParams = new URLSearchParams(queryString);

  if (urlParams.has('customer_posted')) return;

  if (urlParams.has('form_type')) {
    urlParams.append('customer_posted', true);

    window.history.pushState({}, '', `page?${urlParams}`);
  }

  for (const [key, value] of urlParams.entries()) {
    if (key === 'customer_posted' && value === 'true') {
      document.getElementById('newsletter-form__message-hidden').classList.remove('hidden');
    }
  }
});

window.checkFreeShippings = () => {
  if (typeof Weglot !== 'undefined') {
    Shopify.money_format = "€{{amount}}";
    let VALUES = JSON.parse(document.getElementById("ShippingCostsValues").innerHTML);
    //console.log(VALUES);
    const lang = Weglot.getCurrentLang();

    let free_shipping_threshold_field = lang
    if (!VALUES[free_shipping_threshold_field]) {
      free_shipping_threshold_field = 'default';
    }

    let free_shipping_threshold = VALUES[free_shipping_threshold_field];

    if (!free_shipping_threshold) return;

    free_shipping_threshold = parseInt(free_shipping_threshold) * 100;

    let cart_total = parseInt(VALUES.cart_total);
    //console.log(cart_total)
    //console.log(free_shipping_threshold)

    if (cart_total > free_shipping_threshold) {
        let el = document.querySelector(".totals__shipping-value");
        el.innerHTML = VALUES.text;

        el = document.querySelector(".totals__order-total-value");
        el.innerHTML = Shopify.formatMoney(cart_total);
    } else {
        let el = document.querySelector(".totals__shipping-value");
        //console.log(Shopify);
        el.innerHTML = Shopify.formatMoney(VALUES.cost);

        let total_total = cart_total+ VALUES.cost;
        //console.log(total_total);
        el = document.querySelector(".totals__order-total-value");
        el.innerHTML = Shopify.formatMoney(total_total);   
    }
    return;
  }
 if (document.getElementById("ShippingCostsValuesMarkets")){
  const MARKETS_COSTS = JSON.parse(document.getElementById("ShippingCostsValuesMarkets").innerHTML);
  if (MARKETS_COSTS.markets != null) {
    const HOST = window.location.hostname;
    //console.log({HOST});
    const free_shipping = MARKETS_COSTS.markets[HOST];
    //console.log({free_shipping});
    if (!free_shipping) return;

    let free_shipping_threshold = parseInt(free_shipping) * 100;
    let cart_total = parseInt(MARKETS_COSTS.cart_total);
    let thresholdConfig = JSON.parse(document.getElementById("thresholdConfig").innerHTML);
    let remaining = Math.round((cart_total / free_shipping_threshold)*100);

    const thresoldSection =  document.querySelector("#cart-threshold-goal");
    var styleElem = thresoldSection.appendChild(document.createElement("style"));
    styleElem.innerHTML = `#cart-threshold-goal .cart__progress-bar::after {transform: translateX( ${remaining}%);}`;
    if (remaining > 0 && remaining < 100) {
      const progress = (free_shipping_threshold - cart_total);
      thresoldSection.querySelector("p").outerHTML =thresholdConfig.remain_copy.replace("$amount",  Shopify.formatMoney(progress));
    } else {
      thresoldSection.querySelector("p").outerHTML =thresholdConfig.success_copy;
    }

    if (cart_total > free_shipping_threshold) {
        let el = document.querySelector(".totals__shipping-value");
        el.innerHTML = MARKETS_COSTS.text;

        el = document.querySelector(".totals__order-total-value");
        el.innerHTML = Shopify.formatMoney(cart_total);
    } else {
        let el = document.querySelector(".totals__shipping-value");
        el.innerHTML = Shopify.formatMoney(MARKETS_COSTS.cost);

        let total_total = cart_total+ MARKETS_COSTS.cost;
        el = document.querySelector(".totals__order-total-value");
        el.innerHTML = Shopify.formatMoney(total_total);   
    }

  }
  }
};
window.addEventListener('DOMContentLoaded', (event) => {
  window.checkFreeShippings()
});

class TimerCountdown extends HTMLElement {
  constructor() {
    super();

    this.endDate = this.dataset.endDate;
    if (!this.endDate) return;

    this.config = {
      text: this.dataset.countdownText || "",
      text_color: this.dataset.countdownTextColor || "#000",
      countdown_color: this.dataset.countdownColor || "#000",
      show_dot: this.dataset.showPulsatingDot || true,
      timezone: this.dataset.timezone || ""
    }

    this.attachShadow({ mode: 'open' });
    this.appendStyles();
    this.countdown();
  }

  countdown() {
    let countDownDate = new Date(this.endDate).getTime();
    let shadow = this.shadowRoot;

    this.container = document.createElement('div');
    shadow.appendChild(this.container);

    let int = setInterval(function() {
      let newNowDate = new Date();
      let now = newNowDate.getTime();
      if (this.config.timezone && this.config.timezone != "") {
        now = new Date(newNowDate.toLocaleString("en-US", { timeZone: this.config.timezone }));
      }
      let distance = countDownDate - now;

      let days = Math.floor(distance / (1000 * 60 * 60 * 24));
      let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (days < 10) days = "0" + days;
      if (hours < 10) hours = "0" + hours;
      if (minutes < 10) minutes = "0" + minutes;
      if (seconds < 10) seconds = "0" + seconds;

      this.container.innerHTML = `
        ${this.config.show_dot == "true" ? "<span class='countdown-dot'></span>" : ""}
        <span style="color:${this.config.text_color};">${this.config.text}</span>
        <span style="color:${this.config.countdown_color};">[${days}:${hours}:${minutes}:${seconds}]<span>
      `;

      if (distance < 0) {
        clearInterval(int);
        this.container.innerHTML = "<span>Now available!<span>";
      }
    }.bind(this), 1000);
  }

  appendStyles() {
    const style = document.createElement('style'); 
    style.innerHTML=`  
      div {
        display: flex;
        align-items: center;
        gap: 8px;
      }

      .countdown-dot {
        height: 14px;
        width: 14px;
        background-color: ${this.config.text_color};
        border-radius: 50%;
        display: inline-block;
        animation: pulse 1s infinite;
      }

      @keyframes pulse {
        0% {
          transform: scale(0.8);
          opacity: 0.1;
        }
        50% {
          transform: scale(1);
          opacity: 1;
        }
        100% {
          transform: scale(0.8);
          opacity: 0.1;
        }
      }
    `;
    this.shadowRoot.appendChild(style);
  }
}
customElements.define('timer-countdown', TimerCountdown);